import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class SalesGroupOwnerService {
  private apiUrl = '/salesgroupowners';
  private apiSpringUrl = '/spring/salesgroupowners';

  constructor(private http: HttpService) { }

  get(ownerId?: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
    return this.http.get(url);
  }

  post(
    ownerId: number,
    ownerTx: string,
    salesgroupId: number,
    salesgroupTx: string,
    unitpricedispNr: number,
    typetaxCd: number,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    const jsonInput = {
      ownerId: ownerId,
      ownerTx: ownerTx,
      salesgroupId: salesgroupId,
      salesgroupTx: salesgroupTx,
      unitpricedispNr: unitpricedispNr,
      typetaxCd: typetaxCd,
      updprogramCd: updprogramCd
    };
    return this.http.post(url, jsonInput);
  }

  put(
    ownerId: number,
    salesgroupId: number,
    unitpricedispNr: number,
    typetaxCd: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${ownerId}/${salesgroupId}`;
    const jsonInput = {
      unitpricedispNr: unitpricedispNr,
      typetaxCd: typetaxCd,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(
    ownerId: number,
    salesgroupId: number
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${ownerId}/${salesgroupId}`;
    return this.http.delete(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/sales-group-owner/sales-group-owner.service.ts